import { PermissionEffects } from './permission/permission.effects';

export const appEffects = [PermissionEffects];
